import { API } from 'aws-amplify';
import { SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND } from 'constants';

export const getCannedResponses = async () => {
  const cannedResponses = await API.get(
    'delta-api',
    `${SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND}`
  );
  return cannedResponses;
};

export const getCannedResponse = async (responseId) => {
  const cannedResponse = await API.get(
    'delta-api',
    `${SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND}${responseId}`
  );
  return cannedResponse;
};

export const postCannedResponse = async (payload) => {
  const myPayload = {
    body: payload,
  };

  await API.post(
    'delta-api',
    `${SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND}`,
    myPayload
  );
};

export const putCannedResponse = async (payload, responseId) => {
  const myPayload = {
    body: payload,
  };

  await API.put(
    'delta-api',
    `${SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND}${responseId}`,
    myPayload
  );
};

export const togglePinCannedResponse = async (response_id) => {
  await API.patch(
    'delta-api',
    `${SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND}${response_id}/toggle-pin`
  );
};

export const deleteCannedResponse = async (response_id) => {
  await API.del(
    'delta-api',
    `${SSA_PREFERENCES_CANNED_RESPONSES_URL_APPEND}${response_id}`
  );
};
